import styled from 'styled-components';
import { textFontStyles } from '@makemydeal/dr-ui-bricks-components';
import { BreakPoints } from '@makemydeal/dr-ui-bricks-utils';

export const HeaderRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 12px;

    @media (max-width: ${BreakPoints.PHONE}) {
        flex-direction: column;
        align-items: stretch;
    }
`;

export const ActionBar = styled.div<{ $position: 'top' | 'bottom' }>`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 12px;

    @media (max-width: ${BreakPoints.PHONE}) {
        display: flex;
        flex-direction: column-reverse;
        align-items: stretch;
    }

    button {
        width: auto;
        padding: 12px 20px;
        text-transform: none;
        ${textFontStyles('large', 'semibold')};
        @media (max-width: ${BreakPoints.PHONE}) {
            padding: 12px 45px;
        }
    }
`;

export const ViewQuoteContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 30px;
`;
